/* eslint-disable */
if (__PROD__) {
  module.exports = require('./configureStore.prod'); // eslint-disable-line
} else {
  module.exports = require('./configureStore.dev'); // eslint-disable-line
}



// WEBPACK FOOTER //
// ./src/state/store/configureStore.js